/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1CourseregistrationEnrollmentPoloMutationResponse,
  PutApiV1CourseregistrationEnrollmentPoloQueryParams,
  PutApiV1CourseregistrationEnrollmentPolo400,
  PutApiV1CourseregistrationEnrollmentPolo401,
  PutApiV1CourseregistrationEnrollmentPolo500,
} from "../../types/courseRegistrationEnrollmentController/PutApiV1CourseregistrationEnrollmentPolo.ts";

function getPutApiV1CourseregistrationEnrollmentPoloUrl() {
  const res = {
    method: "PUT",
    url: `/api/v1/courseregistration/enrollment/polo` as const,
  };
  return res;
}

/**
 * @description Atualiza o polo vinculado a uma matrícula. Quando o polo informado existir, define PoloChangeManual como verdadeiro. Quando a turma tiver o polo bloqueado (IsPoloBlocked), a operação é ignorada sem erro. Requer permissão de empresa sobre a matrícula. **(Requer Authorization para autenticação)**
 * @summary Atualiza o polo de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/polo}
 */
export async function putApiV1CourseregistrationEnrollmentPolo(
  params?: PutApiV1CourseregistrationEnrollmentPoloQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PutApiV1CourseregistrationEnrollmentPoloMutationResponse,
    ResponseErrorConfig<
      | PutApiV1CourseregistrationEnrollmentPolo400
      | PutApiV1CourseregistrationEnrollmentPolo401
      | PutApiV1CourseregistrationEnrollmentPolo500
    >,
    unknown
  >({
    method: "PUT",
    url: getPutApiV1CourseregistrationEnrollmentPoloUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
